// Clases Tailwind compartidas entre los ítems de navegación del sidebar
// (módulo con hijos, enlace de primer nivel y sub-ítem). Centralizar estas
// cadenas evita repetir los mismos utilitarios en cada variante del template.
//
// Regla importante: por cada elemento, el color de texto (y el fondo, cuando
// aplica) sólo debe quedar definido por UN ÚNICO conjunto de clases a la vez
// (activo *o* inactivo, nunca ambos). Combinar `text-text-body` (inactivo) y
// `text-calypso-primary` (activo) en el mismo `class` hace que ambas reglas
// terminen en la hoja de estilos generada por Tailwind, y gana la que quedó
// declarada más abajo — no la que aparece último en el atributo `class` — lo
// que producía texto "azulado" en vez de rojo en el ítem activo. Por eso
// `SidebarNavItemComponent` arma el string final eligiendo un único bloque de
// estado (`*_ACTIVE` o `*_INACTIVE`) en vez de concatenar los dos.

/** Layout base compartido por todos los ítems (sin color). */
export const SIDEBAR_ITEM_BASE = 'flex cursor-pointer items-center rounded-lg transition';

/** Layout de módulo (botón con hijos) y enlace de primer nivel: ícono + texto. */
export const SIDEBAR_MODULE_LAYOUT = 'w-full gap-2.5 px-3 py-2 text-base';

/** Layout de sub-ítem (hijo dentro del árbol expandido): sin ícono, indentado. */
export const SIDEBAR_SUBMODULE_LAYOUT = 'w-full px-3 py-1.5 text-sm';

/**
 * Estado inactivo de módulo/enlace de primer nivel.
 */
export const SIDEBAR_MODULE_INACTIVE =
  'font-medium text-text-body hover:bg-surface-subtle hover:text-text-title';

/**
 * Estado activo de módulo/enlace de primer nivel: texto e ícono rojos, SIN
 * fondo (a diferencia del sub-ítem). El módulo desplegado usa esta misma
 * clase mientras contiene la ruta activa.
 */
export const SIDEBAR_MODULE_ACTIVE = 'font-semibold text-calypso-primary hover:bg-surface-subtle';

/** Estado inactivo de sub-ítem. */
export const SIDEBAR_SUBMODULE_INACTIVE =
  'text-text-muted hover:bg-surface-subtle hover:text-text-title';

/** Estado activo de sub-ítem: pill con fondo y borde tenues (ruta seleccionada). */
export const SIDEBAR_SUBMODULE_ACTIVE =
  'bg-calypso-light text-calypso-primary border border-calypso-border-subtle font-semibold';

/** Color del ícono según si el módulo/enlace está activo. */
export const SIDEBAR_ICON_ACTIVE = 'text-calypso-primary';
export const SIDEBAR_ICON_INACTIVE = 'text-text-muted';
